import React, { useState } from 'react';
import styles from './ContactCard.module.css';

function ContactCard({ contact, onEdit, onArchive }) {
  const [showPopup, setShowPopup] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editableContact, setEditableContact] = useState({ ...contact });

  const getStatusClass = (status) => {
    switch (status.toLowerCase()) {
      case 'urgent':
        return styles.urgent;
      case 'follow up':
        return styles.followUp;
      case 'prospect':
        return styles.prospect;
      default:
        return styles.new;
    }
  };

  const handleFieldChange = (field, value) => {
    setEditableContact(prev => ({ ...prev, [field]: value }));
  };

  return (
    <>
      <div
        className={`${styles.card} ${getStatusClass(contact.status)} card`}
        onClick={() => setShowPopup(true)}
      >
        <div className={styles.avatar}>
          {contact.avatarUrl ? (
            <img src={contact.avatarUrl} alt={contact.name} />
          ) : (
            <span>{contact.name.split(' ').map(w => w[0]).join('')}</span>
          )}
        </div>
        <div className={styles.details}>
          <h3>{contact.name}</h3>
          <p>{contact.title}</p>
          <p>{contact.company}</p>
          <span className={`${styles.badge} ${getStatusClass(contact.status)}`}>
            {contact.status}
          </span>
        </div>
      </div>

      {showPopup && (
        <div className={styles.popupOverlay} onClick={() => setShowPopup(false)}>
          <div className={styles.popupContent} onClick={(e) => e.stopPropagation()}>
            <div className={styles.popupHeader}>
              <div className={styles.popupAvatar}>
                {contact.avatarUrl ? (
                  <img src={contact.avatarUrl} alt={contact.name} />
                ) : (
                  <span>{contact.name.split(' ').map(w => w[0]).join('')}</span>
                )}
              </div>
              <div>
                <h2>{editMode ? (
                  <input
                    type="text"
                    value={editableContact.name || ''}
                    onChange={e => handleFieldChange('name', e.target.value)}
                  />
                ) : (
                  contact.name
                )}</h2>
                <span className={`${styles.badge} ${getStatusClass(contact.status)}`}>
                  {contact.status}
                </span>
              </div>
            </div>
            <div className={styles.popupBody}>
              <p><strong>Title:</strong> {editMode ? (
                <input type="text" value={editableContact.title || ''} onChange={e => handleFieldChange('title', e.target.value)} />
              ) : (contact.title)}</p>
              <p><strong>Company:</strong> {editMode ? (
                <input type="text" value={editableContact.company || ''} onChange={e => handleFieldChange('company', e.target.value)} />
              ) : (contact.company)}</p>
              <p><strong>Email:</strong> {editMode ? (
                <input type="email" value={editableContact.email || ''} onChange={e => handleFieldChange('email', e.target.value)} />
              ) : (contact.email)}</p>
              <p><strong>Phone:</strong> {editMode ? (
                <input type="tel" value={editableContact.phone || ''} onChange={e => handleFieldChange('phone', e.target.value)} />
              ) : (contact.phone)}</p>
              <p><strong>Last Contact:</strong> {editMode ? (
                <input type="text" value={editableContact.lastContact || ''} onChange={e => handleFieldChange('lastContact', e.target.value)} />
              ) : (contact.lastContact)}</p>
              <p><strong>LinkedIn:</strong> {editMode ? (
                <input type="url" value={editableContact.linkedin || ''} onChange={e => handleFieldChange('linkedin', e.target.value)} />
              ) : (
                <a href={contact.linkedin} target="_blank" rel="noopener noreferrer">{contact.linkedin}</a>
              )}</p>
              <p><strong>Website:</strong> {editMode ? (
                <input type="url" value={editableContact.website || ''} onChange={e => handleFieldChange('website', e.target.value)} />
              ) : (
                <a href={contact.website} target="_blank" rel="noopener noreferrer">{contact.website}</a>
              )}</p>
            </div>
            <div className={styles.popupActions}>
              {editMode ? (
                <>
                  <button className={styles.editButton} onClick={() => { onEdit(editableContact); setEditMode(false); setShowPopup(false); }}>Save</button>
                  <button className={styles.cancelButton} onClick={() => setEditMode(false)}>Cancel</button>
                </>
              ) : (
                <button className={styles.editButton} onClick={() => setEditMode(true)}>Edit</button>
              )}
              <button className={styles.archiveButton} onClick={() => { onArchive(contact); setShowPopup(false); }}>Archive</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ContactCard;
